module.exports = __webpack_public_path__ + "4b4726767a4cc52e06fa0a769c4636d9.png";